import classnames from 'classnames'
import React from 'react'
import { Link } from 'react-router-dom'

import styles from './index.module.css'

class Checkbox extends React.Component {
  render() {
    const { value, count, onSelectionChange, checked, link } = this.props
    const checkboxStyles = classnames(styles.checkbox, {
      [styles.checked]: checked
    })

    return (
      <div className={styles.optionWrapper}>
        <Link
          onClick={onSelectionChange.bind(null, value)}
          to={link}
          className={styles.link}
        >
          <span className={checkboxStyles} />
          {this.props.children}
        </Link>
        <span className={styles.count}>{count}</span>
      </div>
    )
  }
}

export default Checkbox
